export function getAmountIncludingTaxes(amountExcludingTaxes: number, VATRate: number) {
  return (amountExcludingTaxes + (VATRate * amountExcludingTaxes) / 100).toFixed(4);
}

export function getAmountExcludingTaxes(amountIncludingTaxes: number, VATRate: number) {
  return ((amountIncludingTaxes * 100) / (100 + VATRate)).toFixed(4);
}
